<div class="ml-1">
  <span class="app-search">
    <input pInputText type="text" name="query" placeholder="Search" i18n-placeholder="@@common-search"
           [(ngModel)]="query" (keydown.enter)="onClickSearch()" class="form-field" />
    <i class="fa fa-solid fa-magnifying-glass" (click)="onClickSearch()"></i>
    <i class="fa fa-solid fa-xmark" (click)="onClickSearch(true)"></i>
  </span>
</div>
